import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApplicationContextStore } from '../application-context/application-context.store';

/**
 * Attaches the currently selected language as the `X-Language` header on every outgoing request.
 *
 * The value is read from {@link ApplicationContextStore.selectedLanguage} per request, so when the
 * user changes language via the language modal every subsequent request picks up the new value
 * automatically.
 *
 * Backend code reads this header via `ICurrentUser.Language` and uses it to resolve translations
 * for server-emitted messages (thrown exceptions, controller responses, etc.) before they go on
 * the wire.
 */
export function languageInterceptor(
    req: HttpRequest<unknown>,
    next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
    const appContext = inject(ApplicationContextStore);
    const language = appContext.selectedLanguage();

    if (!language?.id) {
        return next(req);
    }

    return next(
        req.clone({
            setHeaders: { 'X-Language': language.id },
        }),
    );
}
